import type { QueryClient } from '@tanstack/react-query';
import { BORDEREAU_DOCS_QUERY_KEY } from '@/features/bordereau/hooks/useBordereauDocuments';

/** Refreshes every dossier-document projection after a successful agent mutation. */
export function invalidateCaseDocumentQueries(
  queryClient: QueryClient,
  caseId: string | null,
): void {
  void queryClient.invalidateQueries({ queryKey: ['case-documents', caseId] });
  void queryClient.invalidateQueries({ queryKey: ['case-documents'] });
  void queryClient.invalidateQueries({ queryKey: ['folder-contents', caseId] });
  void queryClient.invalidateQueries({ queryKey: ['folder-contents'] });
  void queryClient.invalidateQueries({ queryKey: ['folder-tree', caseId] });
  void queryClient.invalidateQueries({ queryKey: ['folder-tree'] });
  void queryClient.invalidateQueries({ queryKey: ['renumber-docs', caseId] });
  void queryClient.invalidateQueries({ queryKey: [BORDEREAU_DOCS_QUERY_KEY, caseId] });
  void queryClient.invalidateQueries({ queryKey: [BORDEREAU_DOCS_QUERY_KEY] });
}
